export default "/lineup-tool/assets/redux/arrow-down-white.svg";